import { ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../service/common/notification/notification.service';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { take } from 'rxjs/operators';
import { FeldBeschreibung } from '../../domain/model/feldbeschreibung.model';
import { FeldBeschreibungService } from '../../service/feldbeschreibung/feldbeschreibung.service';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'redispatch-settings-feldbeschreibung-detail',
    templateUrl: './settings-feldbeschreibung-detail.component.html',
    styleUrls: [
        './settings-feldbeschreibung-detail.component.scss',
    ],
    standalone: false,
})
export class SettingsFeldBeschreibungDetailComponent implements OnInit {
    public feld: FeldBeschreibung = new FeldBeschreibung();

    @ViewChild('feldBeschreibungForm', { static: false }) public feldBeschreibungForm: NgForm;

    public westnetzSidenavService = inject(WestnetzSidenavService);
    private feldBeschreibungService = inject(FeldBeschreibungService);
    private activatedRoute = inject(ActivatedRoute);
    private notificationService = inject(NotificationService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    ngOnInit() {
        this.reloadData();
    }

    public resetForm() {
        this.reloadData();
        this.feldBeschreibungForm.form.markAsPristine();
    }

    private reloadData() {
        const moduleId = this.activatedRoute.snapshot.queryParams['feld'];
        this.feldBeschreibungService.getFeldBeschreibung(moduleId)
            .pipe(take(1))
            .subscribe((data: FeldBeschreibung) => {
                this.feld = data;
                this.changeDetectorRef.markForCheck();
            });
    }

    save() {
        this.feldBeschreibungService.updateFeldBeschreibung(this.feld).subscribe(() => {
            this.westnetzSidenavService.closeRightnav();
            this.notificationService.success('Die Anpassungen wurden erfolgreich gespeichert');
        });
    }
}
